<div class="who-we-are-container">
  <builder-content
    [model]="ABOUT_PAGE_MODEL"
    [content]="content"
    [apiKey]="apiKey"
    [customComponents]="customComponents"
  />
</div>
